export const validationMessages = {
  en: {
    custom: {
      phoneNumber: {
        required: 'Please provide your phone number',
        numeric: 'Please provide a valid phone number',
        max: 'Please provide a valid phone number'
      }
    }
  },
  pt_PT: {
    custom: {
      phoneNumber: {
        required: 'Por favor, forneça seu número de telefone',
        numeric: 'Por favor forneça um número de telefone válido',
        max: 'Por favor forneça um número de telefone válido'
      }
    }
  },
  it: {
    custom: {
      phoneNumber: {
        required: 'Fornisci il tuo numero di telefono',
        numeric: 'Si prega di fornire un numero di telefono valido',
        max: 'Si prega di fornire un numero di telefono valido'
      }
    }
  }
};
